import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { IEnvironments } from '../interfaces/IEnvironments';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';


@Injectable({
  providedIn: 'root'
})
export class EnvironmentsService extends RestCallService {
 
  constructor(
    public httpClient: HttpClient,
    private cognitoService: CognitoService,
    public toastr: ToastrService,
    public notificationService: NotificationService,
    public translate: TranslateApplicationService) {
    super(httpClient, 'LockerLinkApi', toastr, notificationService, translate);
  }

  public GetActiveEnvironment() {
    return this.post<IEnvironments[]>('/api/Environments/GetActiveEnvironment');
  }
}
